import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import ProviderLogo from '@components/ProviderLogo'

import useProvider from '@hooks/useProvider'

import type { ProviderModel } from '@models/types'

interface ProviderTileProps {
  callbacks: {
    selectProvider: VoidFunction,
  },
  provider: ProviderModel,
}

const ProviderTile = (props: ProviderTileProps) => {
  const {
    callbacks: {
      selectProvider,
    },
    provider,
  } = props

  const providerPayload = useProvider(provider)
  const {
    isPreferred,
    provider: {
      title,
    },
  } = providerPayload

  return (
    <Box
      alignItems="center"
      as="a"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="5px"
      data-test-id="providerTile"
      height={84}
      marginBottom="medium"
      onClick={() => selectProvider()}
      padding="medium"
      style={{ cursor: 'pointer' }}
    >
      <ProviderLogo
        boxProps={{
          border: 'none',
        }}
        provider={provider}
      />

      <Box
        borderLeft="1px solid"
        borderColor="lineColor"
        flexDirection="column"
        marginLeft="medium"
        paddingLeft="large"
        paddingY="large"
        width="auto"
      >
        <Text fontSize="small">{title}</Text>

        {isPreferred && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            Preferred Supplier
          </Text>
        )}
      </Box>

      {isPreferred && (
        <Box color="blue" marginLeft="auto" width="auto">
          <FontAwesomeIcon icon={faStar} />
        </Box>
      )}
    </Box>
  )
}

export default ProviderTile
